import { Badge } from "@/components/ui/badge";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/ui/tooltip";

import { dates } from "@/lib/dates";
import { formatting } from "@/lib/formatting";
import { CandidacySource } from "@/types";

export const CandidacySourceBadge = ({
  createdAt,
  jobAndLocation,
  source,
}: {
  createdAt: string;
  jobAndLocation: string | null;
  source: CandidacySource | null;
}) => {
  if (!source) return <p>-</p>;

  const title = jobAndLocation?.trim();

  const getSourceContent = () => {
    return (
      <div className="truncate">
        {dates.formatIsoDateForUser(createdAt)} -{" "}
        {formatting.candidacySourceLabel(source)}{" "}
        {/* Bit of a hacky way to prevent the italic text from being cut off using pl (in the badge class) and pr. */}
        {title && (
          <>
            - <i className="pr-1">{title}</i>
          </>
        )}
      </div>
    );
  };
  return (
    <TooltipProvider delayDuration={300}>
      <Tooltip>
        <TooltipTrigger asChild>
          {/* span is required so the tooltip has a reference element to know where to position the tooltip. 
            Badge does not provide the necessary reference */}
          <span className="truncate">
            <Badge variant="outline" className="max-w-full pl-3">
              {getSourceContent()}
            </Badge>
          </span>
        </TooltipTrigger>
        <TooltipContent side="top">{getSourceContent()}</TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
};
